<template>
  <Navbar regloginpass logourl="/rental" />

  <section id="afterRegistrationInfo">
    <div class="container pt-5">
      <div class="section-caption">
        <h2>Rejestracja</h2>
      </div>
      <div class="tile">
        <div class="section-content">
          <Alert
            alert-type="alert-success"
            alert-text="Rejestracja zakończona powodzeniem.
            Na podany wcześniej adres email została wysłana wiadomość z linkiem potwierdzającym rejestrację - kliknij go, aby móc się zalogować na konto.
            Sprawdź folder SPAM na swojej poczcie, jeśli nie możesz odnaleźć wiadomości z linkiem potwierdzającym."
          />
          <div class="text-center">
            <button class="btn-standard" @click="onMainPageButtonClick">
              Zaloguj
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Stopka -->
  <Footer />
</template>

<script>
import { scrollToTop } from "@/utils/helpers";
import Alert from "@/components/Alert.vue";
import Footer from "@/components/Footer.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  name: "RegistrationCompleteView",
  components: { Navbar, Footer, Alert },

  mounted() {
    scrollToTop();
  },

  methods: {
    onMainPageButtonClick() {
      this.$router.push(this.routePath.Login);
    },
  },
};
</script>

<style scoped></style>
